import Vue from "vue";
import VueRouter from "vue-router";
import ElementsIndex from "../views/ElementsIndex.vue";
import ElementsShow from "../views/ElementsShow.vue";
import ElementsCreate from "../views/ElementsCreate.vue";
import ElementsCopy from "../views/ElementsCopy.vue";
import Search from "../views/Search.vue";
import GroupsIndex from "../views/GroupsIndex.vue";
import GroupsShow from "../views/GroupsShow.vue";
import Params from "../views/Params.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/elements"
  },
  {
    path: "/elements",
    component: ElementsIndex,
    name: "ElementIndex"
  },
  {
    path: "/elements/create",
    component: ElementsCreate,
    name: "ElementCreate"
  },
  {
    path: "/elements/:_id",
    component: ElementsShow,
    name: "ElementShow"
  },
  {
    path: "/elements/:_id/create",
    component: ElementsCopy,
    name: "ElementCopy"
  },
  {
    path: "/search",
    component: Search,
    name: "Search"
  },
  {
    path: "/groups",
    component: GroupsIndex,
    name: "GroupsIndex"
  },
  {
    path: "/groups/:_id",
    component: GroupsShow,
    name: "GroupsShow"
  },
  {
    path: "/params",
    component: Params,
    name: "Params"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
